import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { io } from 'socket.io-client';
import Paquetes from '../components/Paquetes';
import Instalaciones from '../components/Instalaciones';
import TiposReconexion from '../components/TiposReconexion';
import Clientes from '../components/Clientes';
import Facturas from '../components/Facturas';
import Pagos from '../components/Pagos';
import Cortes from '../components/Cortes';
import Usuarios from '../components/Usuarios';
import Configuracion from '../components/Configuracion';
import Panel from '../components/Panel';
import Morosos from '../components/Morosos';
import Reportes from '../components/Reportes';
import PanelTiempoReal from '../components/PanelTiempoReal';
import Zonas from '../components/Zonas';
import MapaCobradores from '../components/MapaCobradores';
import MapaClientes from '../components/MapaClientes';
import RendicionCobradores from '../components/RendicionCobradores';
import ArqueoCaja from '../components/ArqueoCaja';
import EstadisticasZona from '../components/EstadisticasZona';
import Averias from '../components/Averias';
import Materiales from '../components/Materiales';
import PlanesPago from '../components/PlanesPago';
import Tuberias from '../components/Tuberias';
import YapeNotificaciones from '../components/YapeNotificaciones';

// ── Global Yape toast (visible from any page) ─────────────────────────────
const YapeGlobalToast: React.FC = () => {
  const [toasts, setToasts] = useState<{ id: number; monto: number; nombrePagador: string; confianza: string }[]>([]);

  useEffect(() => {
    const base = process.env.REACT_APP_API_URL?.replace('/api/v1', '') || '';
    const socket = io(`${base}/yape`, { transports: ['websocket'] });

    socket.on('nueva_yape', (notif: any) => {
      const id = Date.now();
      setToasts(prev => [...prev, {
        id,
        monto: Number(notif.monto || 0),
        nombrePagador: notif.nombrePagador || 'Desconocido',
        confianza: notif.confianza || 'bajo',
      }]);
      setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 8000);
    });

    return () => { socket.disconnect(); };
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div style={{ position: 'fixed', top: 20, right: 20, zIndex: 10000, display: 'flex', flexDirection: 'column', gap: 10, pointerEvents: 'none' }}>
      {toasts.map(t => (
        <div key={t.id} style={{
          background: t.confianza === 'alto' ? '#14532d' : '#1e293b',
          border: `1px solid ${t.confianza === 'alto' ? '#22c55e' : '#f59e0b'}`,
          borderRadius: 10, padding: '12px 18px', color: '#f1f5f9',
          boxShadow: '0 4px 20px #00000066', minWidth: 280,
        }}>
          <div style={{ fontWeight: 700, fontSize: 14 }}>🟡 Nuevo pago Yape: S/{t.monto.toFixed(2)}</div>
          <div style={{ color: '#94a3b8', fontSize: 13, marginTop: 3 }}>De: {t.nombrePagador}</div>
        </div>
      ))}
    </div>
  );
};

const menuItems = [
  { path: '/', label: 'Panel', icon: '📊' },
  { path: '/clientes', label: 'Clientes', icon: '👥' },
  { path: '/paquetes', label: 'Paquetes', icon: '📦' },
  { path: '/instalaciones', label: 'Instalaciones', icon: '🔧' },
  { path: '/reconexiones', label: 'Reconexiones', icon: '🔌' },
  { path: '/facturas', label: 'Facturas', icon: '🧾' },
  { path: '/pagos', label: 'Pagos', icon: '💰' },
  { path: '/cortes', label: 'Cortes', icon: '✂️' },
  { path: '/morosos', label: 'Morosos', icon: '⚠️' },
  { path: '/reportes', label: 'Reportes', icon: '📈' },
  { path: '/tiempo-real', label: 'Tiempo Real', icon: '⏱' },
  { path: '/mapa-cobradores', label: 'Mapa Cobradores', icon: '📍' },
  { path: '/mapa-clientes', label: 'Mapa Clientes', icon: '🗺️' },
  { path: '/rendicion', label: 'Rendicion', icon: '📋' },
  { path: '/zonas', label: 'Zonas', icon: '🗺️' },
  { path: '/estadisticas-zona', label: 'Stats por Zona', icon: '📊' },
  { path: '/caja', label: 'Caja / Arqueo', icon: '🏦' },
  { path: '/averias', label: 'Averias', icon: '🔧' },
  { path: '/materiales', label: 'Materiales', icon: '📦' },
  { path: '/planes-pago', label: 'Planes de Pago', icon: '💳' },
  { path: '/tuberias', label: 'Tuberias', icon: '🗺️' },
  { path: '/yape', label: 'Pagos Yape', icon: '💳' },
  { path: '/usuarios', label: 'Usuarios', icon: '👤' },
  { path: '/configuracion', label: 'Configuracion', icon: '⚙️' },
];

const routeElements: Record<string, React.ReactElement> = {
  '/': <Panel />,
  '/clientes': <Clientes />,
  '/paquetes': <Paquetes />,
  '/instalaciones': <Instalaciones />,
  '/reconexiones': <TiposReconexion />,
  '/facturas': <Facturas />,
  '/pagos': <Pagos />,
  '/cortes': <Cortes />,
  '/morosos': <Morosos />,
  '/reportes': <Reportes />,
  '/tiempo-real': <PanelTiempoReal />,
  '/mapa-cobradores': <MapaCobradores />,
  '/mapa-clientes': <MapaClientes />,
  '/rendicion': <RendicionCobradores />,
  '/zonas': <Zonas />,
  '/estadisticas-zona': <EstadisticasZona />,
  '/caja': <ArqueoCaja />,
  '/averias': <Averias />,
  '/materiales': <Materiales />,
  '/planes-pago': <PlanesPago />,
  '/tuberias': <Tuberias />,
  '/yape': <YapeNotificaciones />,
  '/usuarios': <Usuarios />,
  '/configuracion': <Configuracion />,
};

// Roles no listados aqui (gerente, admin) tienen acceso a todos los modulos.
const ACCESO_POR_ROL: Record<string, string[]> = {
  soporte: ['/cortes'],
  administrador: ['/', '/clientes', '/facturas', '/pagos', '/paquetes', '/morosos', '/cortes', '/reportes', '/caja', '/averias', '/tuberias', '/yape'],
  cobrador: ['/', '/clientes', '/facturas', '/pagos', '/cortes', '/caja'],
  tecnico: ['/', '/averias', '/cortes', '/caja', '/tuberias'],
};

const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const usuario = JSON.parse(localStorage.getItem('usuario') || '{}');
  const rutasPermitidas = ACCESO_POR_ROL[usuario.rol];

  const itemsVisibles = rutasPermitidas ? menuItems.filter(m => rutasPermitidas.includes(m.path)) : menuItems;

  const cerrarSesion = () => {
    localStorage.clear();
    window.location.href = '/login';
  };

  return (
    <div style={{ display:'flex', minHeight:'100vh', background:'#020617', color:'#e2e8f0' }}>
      <YapeGlobalToast />
      <div style={{ width:220, background:'#0f172a', borderRight:'1px solid #1e293b', display:'flex', flexDirection:'column', position:'fixed', height:'100vh' }}>
        <div style={{ padding:'20px 16px', borderBottom:'1px solid #1e293b' }}>
          <div style={{ fontSize:28, textAlign:'center' }}>💧</div>
          <div style={{ color:'#38bdf8', fontWeight:800, fontSize:16, textAlign:'center' }}>Sistema Agua</div>
          <div style={{ color:'#64748b', fontSize:11, textAlign:'center', marginTop:4 }}>{usuario.nombre} {usuario.apellido}</div>
        </div>
        <nav style={{ flex:1, padding:'12px 8px', overflowY:'auto' }}>
          {itemsVisibles.map(item => (
            <div key={item.path} onClick={() => navigate(item.path)}
              style={{ padding:'10px 14px', borderRadius:8, cursor:'pointer', marginBottom:4, display:'flex', alignItems:'center', gap:10,
                background: location.pathname === item.path ? '#0ea5e922' : 'transparent',
                color: location.pathname === item.path ? '#38bdf8' : '#94a3b8',
                fontWeight: location.pathname === item.path ? 700 : 400 }}>
              <span>{item.icon}</span>
              <span style={{ fontSize:14 }}>{item.label}</span>
            </div>
          ))}
        </nav>
        <div style={{ padding:'16px 8px', borderTop:'1px solid #1e293b' }}>
          <div onClick={cerrarSesion} style={{ padding:'10px 14px', borderRadius:8, cursor:'pointer', color:'#ef4444', display:'flex', alignItems:'center', gap:10 }}>
            <span>🚪</span><span style={{ fontSize:14 }}>Cerrar Sesion</span>
          </div>
        </div>
      </div>

      <div style={{ marginLeft:220, flex:1, padding:24 }}>
        <Routes>
          {(rutasPermitidas || Object.keys(routeElements)).map(path => (
            <Route key={path} path={path} element={routeElements[path]} />
          ))}
          {rutasPermitidas && <Route path="*" element={<Navigate to={rutasPermitidas[0] || '/'} replace />} />}
        </Routes>
      </div>
    </div>
  );
};

export default Dashboard;
